
      import Ordered from './ordered.vue'
      import type { App, Plugin } from 'vue'

      export const OrderedPlugin: Plugin = {
        install(app: App) {
          app.component('Ordered', Ordered)
        },
      }
      export { Ordered }
      